import { Cloudinary } from '@cloudinary/url-gen';

export function getCloudinaryImageFromFullUrl(encodedImageURL: string) {
  if (!encodedImageURL) return null;
  let unescapedUrl = decodeURIComponent(encodedImageURL);

  const cloudinaryUrlPattern = '(upload\\/)(.*?)(v\\d*\\/.*)'; //group3

  const cld = new Cloudinary({
    cloud: {
      cloudName: 'carbonclick',
    },
    url: {
      secure: true, // force https, set to false to force http
    },
  });

  const match = unescapedUrl.match(cloudinaryUrlPattern);
  if (match) {
    let match1 = match[3];
    return cld.image(match1);
  } else {
    console.error('Invalid Cloudinary image URL:' + unescapedUrl);
    return null;
  }
}
